import * as React from 'react';
import { connect } from 'react-redux';

import '../Main.scss';

import { ApplicationState } from '../../Store';
import { IsMultiTenant } from '../../Store/AppSettings';

import { Login } from './Login';
import { MultiTenantLogin } from './MultiTenantLogin';

import {
    TenantLoginText,
} from '../../Store/Tenant';

type InjectedReduxState = {
    isMultiTenant: boolean;
};

type InjectedActionCreators = {};

type LoginContainerProps = {};

type Props = LoginContainerProps & InjectedReduxState & InjectedActionCreators;

const LoginContainerComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        isMultiTenant,
    } = props;

    const defaultWelcomeTextLine1: TenantLoginText = {
        bold: true,
        bottomMargin: 0,
        content: ``,
        fontSize: 20

    };

    const defaultWelcomeText = [defaultWelcomeTextLine1];

    const content = React.useMemo(() => {
        return isMultiTenant ? 
            (
                <MultiTenantLogin 
                    defaultWelcomeText={defaultWelcomeText}
                />
            ) : 
            (
                <Login 
                    defaultWelcomeText={defaultWelcomeText}
                />
            );
            
        // These are the only dependencies I want.
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [isMultiTenant])

    return content;
}

export const LoginContainer = connect<InjectedReduxState, InjectedActionCreators, LoginContainerProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            isMultiTenant: IsMultiTenant(appState),
        };

        return result;
    }
)(LoginContainerComponent);
